import { ProductMetaAction, IProductsMetaState, ProductMetaActionType } from './types'

const initialState: IProductsMetaState = {
  page: 1,
  perPage: 20,
  sort: 'id.desc',
  createdAt: [],
  query: '',
  userId: null,
  carrierId: null,
  inventoryLocationId: null,
  supplierId: null,
  listingStrategyId: null,
  categoryIds: null,
  active: null,
  draft: null,
  hideFulfilled: null,
  recycled: null,
  excludePrinted: null,
  onlyAuthenticated: false,
  tags: [],
  ignoreRecycledFilter: true,
  total: 0
}

export default function ProductMetaReducer(state = initialState, action: ProductMetaActionType): IProductsMetaState {
  switch (action.type) {
    case ProductMetaAction.UPDATE_META:
      return { ...state, ...action.payload }

    case ProductMetaAction.RESET_META:
      return initialState

    default:
      return state
  }
}
